import client from './client';

export async function list(params = {}) { const { data } = await client.get('/api/departments', { params }); return data; }
export async function get(id)           { const { data } = await client.get(`/api/departments/${id}`); return data; }
export async function create(body)      { const { data } = await client.post('/api/departments', body); return data; }
export async function update(id, body)  { const { data } = await client.put(`/api/departments/${id}`, body); return data; }
export async function remove(id)        { const { data } = await client.delete(`/api/departments/${id}`); return data; }
